export default "__VITE_ASSET__DdoJb_Ci__"